import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';

const barDefault = {
  xAxisProps: {
    dataKey: 'name',
    textAnchor: 'end',
    verticalAnchor: 'end',
    scaleToFit: false,
    interval: 0,
    fontSize: '10px',
  },
  yAxisProps: {
    fontSize: '10px',
  },
};

const MiscellaneousFeesChartComponent = ({ chartData }) => {
  return (
    <ResponsiveContainer width="100%" height={400} className="mw-100">
      <AreaChart
        data={chartData}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#7f9bdb" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#7790CB" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#b0ffec" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8EEED7" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid height={1} y={0} />
        <XAxis {...barDefault.xAxisProps} dataKey="name" />
        <YAxis axisLine={false} tick={false} />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="WAITING FOR PAYMENT"
          stackId="1"
          stroke="#5272AA"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorUv)"
        />
        <Area
          type="monotone"
          dataKey="PENDING"
          stackId="2"
          stroke="#8EEED7"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorPv)"
        />
        <Area
          type="monotone"
          dataKey="PAID"
          stackId="2"
          stroke="#7790CB"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorPv)"
        />
        <Area
          type="monotone"
          dataKey="EXPIRED REFERENCE NUMBER"
          stackId="2"
          stroke="#AFF2F3"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorPv)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

MiscellaneousFeesChartComponent.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
};

export default MiscellaneousFeesChartComponent;
